export default {
  club_name: 'Frölunda HC',
  club_name_short: 'frolunda',
  stadium_name: '',
  staging_url: 'https://frolunda.api.fangroup.io',
  prod_url: 'https://frolunda.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/frolunda',
  club_logo: '/assets/teams/frolunda.png',
  app_name: 'frolunda',
  websale_name: 'frolunda',
  ntb_team_id: 10054,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'frolunda',
  monolithEnabled: false,
};
